/**
 * Jun-2026 (· 260, User-Wunsch) — Spiegelt die Anzahl der offenen, mir
 * zugewiesenen Aufgaben in den Browser-Tab-Titel (z. B. „(3) TwoWheels …").
 *
 * Global gemountet, sodass der Zähler auch sichtbar ist, wenn man sich gerade
 * NICHT auf dem Dashboard befindet. Überfällige Aufgaben werden mit ⏰ markiert.
 * Rendert nichts (reiner Seiteneffekt).
 */
import { useEffect, useRef } from "react";
import api from "../lib/api";

const POLL_MS = 60000;
const TITLE_RE = /^(?:⏰\s*)?\(\d+\)\s*/; // bestehenden Badge-Präfix entfernen

export default function TaskTitleBadge({ enabled }) {
    const timerRef = useRef(null);

    useEffect(() => {
        if (!enabled) return undefined;
        let cancelled = false;

        const applyBadge = (count, overdue) => {
            const base = (document.title || "TwoWheels").replace(TITLE_RE, "");
            document.title = count > 0 ? `${overdue ? "⏰ " : ""}(${count}) ${base}` : base;
        };

        const poll = async () => {
            try {
                const { data } = await api.get("/me/tasks");
                if (cancelled) return;
                const items = Array.isArray(data) ? data : (data?.items || []);
                const overdue = items.some((t) => t.overdue);
                applyBadge(items.length, overdue);
            } catch { /* still — Titel unverändert lassen */ }
        };

        poll();
        timerRef.current = setInterval(poll, POLL_MS);
        return () => {
            cancelled = true;
            if (timerRef.current) clearInterval(timerRef.current);
            // Badge beim Abmelden/Unmount entfernen
            document.title = (document.title || "TwoWheels").replace(TITLE_RE, "");
        };
    }, [enabled]);

    return null;
}
